// removed by extract-text-webpack-plugin
module.exports = {"component":"R8aW_hGtizTuvF9-5evdA"};